// @ts-nocheck
import React, { useCallback } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { Icon } from '@/components';
import { compose } from '@/utils';
import withDialogActions from '@/containers/Dialog/withDialogActions';
import { DialogsName } from '@/constants/dialogs';

function LogoLibraryActions({ openDialog }) {
  const handleNewLogo = useCallback(() => {
    openDialog(DialogsName.LogoLibraryForm, { action: 'new', logo: null });
  }, [openDialog]);

  return (
    <Button
      icon="plus"
      className='logo-library-primary-btn'
      onClick={handleNewLogo}
    >
      Add New Logo
    </Button>
  );
}

export default compose(withDialogActions)(LogoLibraryActions);
